<template>
  <input
      type="text"
      :value="formatted"
      @input="handleInput"
      @blur="handleBlur"
      @keypress="preventNonNumeric"
      inputmode="numeric"
      v-bind="$attrs"
      style="text-align: right"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      raw: String(Number(this.value) || 0)
    };
  },
  watch: {
    value(newVal) {
      const clean = this.raw.replace(/\D/g, '');
      if (String(newVal) !== clean) {
        this.raw = String(Number(newVal) || 0);
      }
    }
  },
  computed: {
    formatted() {
      const cleaned = this.raw.replace(/\D/g, '');
      return cleaned.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }
  },
  methods: {
    preventNonNumeric(e) {
      if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
      }
    },
    handleInput(e) {
      const onlyNumbers = e.target.value.replace(/\D/g, '');
      this.raw = onlyNumbers;
      this.$emit('input', Number(onlyNumbers || 0)); // important pour v-model
    },
    handleBlur() {
      if (this.raw.trim() === '') {
        this.raw = '0';
        this.$emit('input', 0);
      }
    }
  }
};
</script>
